import assign from 'lodash/assign'

export default AdwordsService

/** @ngInject */
function AdwordsService($window, ErrorCatcher) {
    const buildConversion = (label) => function (orderId) {
        if ($window.google_trackConversion) {
            const orderIdData = orderId ? { google_conversion_order_id: orderId } : {}
            const trackValue = assign(
        {},
                {
                    google_conversion_id: 854892059,
                    google_conversion_label: label,
                    google_conversion_language: 'en',
                    google_conversion_format: '3',
                    google_conversion_color: 'ffffff',
                    google_remarketing_only: false,
                },
        orderIdData)
            return $window.google_trackConversion(trackValue)
        }
        return ErrorCatcher.catchErrorWithoutRedirect({
            message: '$window.google_trackConversion not loaded.',
            label,
            orderId,
        })
    }

    return {
        fireSlimpaySuccessRedirect: buildConversion('2BDTCNul2HAQm7zSlwM'),
    }
}



// WEBPACK FOOTER //
// ./src/services/adwords/adwords.js